import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { EventFieldType } from 'types/EventField';
import { DateTimeFormat, TimeInterval } from 'types/EventState';
import { getEventIdFromSlug } from 'utils/events';
import {
  initialDateTimeFormat,
  initialTimeInterval,
} from '../TicketSalePage/slice/initialValues';
import { useDispatch } from 'react-redux';
import { setVendorData } from 'store/vendorSlice';

export interface FreeEventTicketType {
  id: string;
  name: string;
  isWhitelisted: boolean;
}

export interface FreeEventRegistrationPageData {
  isLoading: boolean;
  hasOrderablePrivateTicketTypes: boolean;
  numberOfPublicTicketTypes: number;
  ticketTypes: FreeEventTicketType[];
  registrationform: EventFieldType[] | null;
  event: {
    name: string;
    location: string;
    dateTimeFormat: DateTimeFormat;
    timeInterval: TimeInterval;
    checkoutConfiguration: {
      orderConfirmationPageText: string;
    };
  };
}

const initialData = {
  isLoading: true,
  hasOrderablePrivateTicketTypes: false,
  numberOfPublicTicketTypes: 0,
  ticketTypes: [],
  registrationform: null,
  event: {
    name: '',
    location: '',
    dateTimeFormat: initialDateTimeFormat,
    timeInterval: initialTimeInterval,
    checkoutConfiguration: {
      orderConfirmationPageText: '',
    },
  },
};

const useFreeEventData = () => {
  const [data, setData] = useState<FreeEventRegistrationPageData>(initialData);
  const { eventSlug } = useParams();
  const [searchParams] = useSearchParams();
  const eventId = getEventIdFromSlug(eventSlug);
  const dispatch = useDispatch();

  const getData = async () => {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API_URL
      }/event/${eventId}?include=hasOrderablePrivateTicketTypes,orderableTicketTypes,orderableTicketTypes.isWhitelisted,registrationform,location,dateTimeFormat,timeInterval,seller_public_information,sellerFeatures,checkoutConfiguration.orderConfirmationPageText${
        searchParams.get('preview') ? '&preview=true' : ''
      }`,
    );

    setData({
      isLoading: false,
      hasOrderablePrivateTicketTypes:
        response.data.hasOrderablePrivateTicketTypes,
      numberOfPublicTicketTypes: response.data.orderableTicketTypes.length,
      ticketTypes: response.data.orderableTicketTypes,
      registrationform: response.data.registrationform,
      event: {
        name: response.data.name,
        location: response.data.location,
        dateTimeFormat: response.data.dateTimeFormat,
        timeInterval: response.data.timeInterval,
        checkoutConfiguration: {
          orderConfirmationPageText:
            response.data.checkoutConfiguration.orderConfirmationPageText,
        },
      },
    });

    dispatch(
      setVendorData({
        id: response.data.id_seller,
        features: response.data.sellerFeatures,
        publicInformation: response.data.seller_public_information,
      }),
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return { data, setData };
};

export default useFreeEventData;
